import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Landing from './Landing';
import SignIn from './SignIn';
import SignUp from './SignUp';
import Dashboard from './Dashboard';
import UploadProduct from './UploadProduct';
import Garments from './Garments';
import Chat from './Chat';
import { auth, analytics } from './firebase';
import { setAnalyticsCollectionEnabled } from 'firebase/analytics';
import './App.css';
import Navbar from './Navbar';
import CookieBanner from './CookieBanner';

function App() {
  const [user, setUser] = useState(null);
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent === 'accepted') {
      setAnalyticsCollectionEnabled(analytics, true);
    } else if (cookieConsent === 'rejected') {
      setAnalyticsCollectionEnabled(analytics, false);
    } else {
      setShowCookieBanner(true);
    }

    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        setUser(user);
        if (location.pathname === '/signin' || location.pathname === '/signup' || location.pathname === '/') {
          navigate('/dashboard');
        }
      } else {
        setUser(null);
        if (location.pathname !== '/signin' && location.pathname !== '/signup' && location.pathname !== '/') {
          navigate('/');
        }
      }
    });

    return () => unsubscribe();
  }, [navigate, location.pathname]);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setAnalyticsCollectionEnabled(analytics, true);
    setShowCookieBanner(false);
  };

  const handleRejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setAnalyticsCollectionEnabled(analytics, false);
    setShowCookieBanner(false);
  };

  const showNavbar = user && location.pathname !== '/signin' && location.pathname !== '/signup' && location.pathname !== '/';

  return (
    <div className="App">
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/upload" element={<UploadProduct />} />
        <Route path="/garments" element={<Garments />} />
        <Route path="/chat" element={<Chat />} />
      </Routes>
      {showCookieBanner && <CookieBanner onAccept={handleAcceptCookies} onReject={handleRejectCookies} />}
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
